import { Button, Grid } from '@mui/material';
import React from 'react';

const CustomTabs = ({tabs,selected,onClick,cols=4}) => {
    // function onClick(name) {
    //     console.log("name trust info:", name);
    //     setSelected(name);
    //     // setOption(getItem(name));
    // }
    return ( 
        tabs.map(tab => <Grid item sm={12} md={cols}>
            {tab.name === selected ? <Button className='tabs' color='default' fullWidth variant='contained' onClick={() => onClick(tab.name)}> {tab.label} </Button> : <Button className='tabs' color='outlinedDefault' fullWidth variant='outlined' onClick={() => onClick(tab.name)}> {tab.label} </Button>}
        </Grid>)
     );
}
 
export default CustomTabs;